import React from "react";
import "../Footer/Footer.scss";
import { useFlags } from 'launchdarkly-react-client-sdk';

export interface IFooterProps {
    LoggedIn: boolean
}

const BUILD_BASE_URL = process.env.REACT_APP_BUILD_BASE_URL;
const COMMUNITY_URL = process.env.REACT_APP_COMMUNITY_URL;
const COMPANY_BASE_URL = process.env.REACT_APP_COMPANY_BASE_URL;
const SUPPORT_BASE_URL = process.env.REACT_APP_SUPPORT_BASE_URL;
const STATUS_BASE_URL = process.env.REACT_APP_STATUS_URL;
const PARTNER_WITH_US_URL = process.env.REACT_APP_PARTNERWITHUS_URL;
const PARTNER_BASE_URL = process.env.REACT_APP_PARTNER_BASE_URL;

const Footer: React.FC<IFooterProps> = (props) => {
    const { showBrandingLink } = useFlags();

    const { showApiMaticDocument } = useFlags();
    let communityLink;
    if (props.LoggedIn == false) {
        communityLink = `${COMMUNITY_URL}/index.html`;
    }
    else {
        communityLink = `${COMMUNITY_URL}/users/login.html`;
    }

    return (
        <div className="footer-container">
            <div className="footer-DevLabel">
                Mindbody Developer
            </div>
            <hr className="divider-dark"></hr>
            <div className="footer-links-container">
                <div className="footer-apis">
                    <h4>APIs</h4>
                    {showApiMaticDocument &&
                        <a id="btn-ftr-get-strt" className="anchor-footer" href="/ui/documentation/public-api" >Getting Started</a>
                    }
                    {!showApiMaticDocument &&
                        <a id="btn-ftr-get-strt" className="anchor-footer" href="/ui/documentation/public-api#/http/mindbody-public-api-v6-0/introduction/getting-started" >Getting Started</a>
                    }
                    {showApiMaticDocument &&
                        <a id="btn-ftr-mb-api" className="anchor-footer" href="/ui/documentation/public-api" >Mindbody API</a>
                    }
                    {!showApiMaticDocument &&
                        <a id="btn-ftr-mb-api" className="anchor-footer" href="/PublicDocumentation/V6" >Mindbody API</a>
                    }                    
                    <a id="btn-ftr-webhook" className="anchor-footer" href="/WebhooksDocumentation" >Webhooks</a>
                </div>
                <div className="footer-resource">
                    <h4>Resources</h4>
                    <a id="btn-ftr-partner-app" className="anchor-footer" href={`${PARTNER_BASE_URL}en-US/home`} target="_blank">Partner Apps</a>
                    <a id="btn-ftr-rel-note" className="anchor-footer" href="/Resources/ApiReleaseNotes" >API Release Notes</a>
                    {showBrandingLink &&
                        <a id="btn-ftr-br" className="anchor-footer" href={`${BUILD_BASE_URL}brand/legal-requirements`} target="_blank">Branding Requirements</a>
                    }
                    <a id="btn-ftr-mb-sys-stat" className="anchor-footer" href={`${STATUS_BASE_URL}`} target="_blank">Mindbody System Status</a>
                </div>
                <div className="footer-partner">
                    <h4>Community</h4>
                    <a id="btn-ftr-partner-us" className="anchor-footer" href={`${PARTNER_WITH_US_URL}`} target="_blank">Partner with Us</a>
                    <a id="btn-ftr-cont-api-spt" className="anchor-footer" href={`${SUPPORT_BASE_URL}s/contactapisupport`} target="_blank">Contact API Support</a>
                </div>


                <div className="footer-ways">
                    <h4>Company</h4>
                    <a id="btn-ftr-abt-us" className="anchor-footer" href={`${COMPANY_BASE_URL}`} target="_blank">About Us</a>
                    <a id="btn-ftr-car" className="anchor-footer" href={`${COMPANY_BASE_URL}careers`} target="_blank">Careers</a>
                    <a id="btn-ftr-contact-us" className="anchor-footer" href={`${COMPANY_BASE_URL}contact-us`} target="_blank">Contact Us</a>
                </div>
            </div>
            <hr className="divider-dark"></hr>
            <span className="footer-copyright-section">
                <span className="footer-copyright">©2023 MINDBODY, Inc.</span>
                <span className="footerLinks">
                    <a id="btn-ftr-api-term" href="/Resources/DeveloperAgreement">API Terms of Use</a>
                    <span className="footer-division-bar"> | </span>
                    <a id="btn-ftr-ser-pol" href="/Resources/SecurityRequirements" >Security Policy</a>
                    <span className="footer-division-bar"> | </span>
                    <a id="btn-ftr-pri-pol" href={`${COMPANY_BASE_URL}privacy-policy`} target="_blank">Privacy Policy</a>
                </span>
            </span>
        </div>
    );
}

export default Footer;